import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DragDropFileList, Text } from '@mercai/clever'
import { CardDocuments, CardDocumentsDataProps } from '@/components'
import { api } from '@/services'

import { DocumentCardProps } from './document-card.type'
import styles from './document-card.module.css'

export const DocumentCard = ({
  title,
  file,
  addUrl,
  fileField,
  method,
  onSuccessUpload,
}: DocumentCardProps) => {
  const { t } = useTranslation('screenProfileShow')

  const [isEdit, setIsEdit] = useState(true)
  const [fileObj, setFileObj] = useState<CardDocumentsDataProps[] | undefined>(
    undefined,
  )

  const onUpload = () => {
    setIsEdit(false)
    onSuccessUpload()
  }

  const getFileValue = (file: string | undefined) => {
    if (!file) {
      return []
    }

    return [
      {
        title,
        file: file as string,
        previewDocument: false,
        onUpdate: () => setIsEdit(true),
      },
    ]
  }

  useEffect(() => {
    if (file) {
      const getFile = getFileValue(file)

      setFileObj(getFile)
      setIsEdit(false)
    }
  }, [file])

  if (isEdit) {
    return (
      <div className={styles.container}>
        <Text>{title}</Text>
        <DragDropFileList
          translations={{
            dragFile: t('uploadDragFile'),
            clickToUpload: t('uploadClickToUpload'),
            sizeFile: t('uploadSizeFile'),
          }}
          urlAdd={addUrl}
          configsRequest={{
            fileField,
            method,
          }}
          axiosInstance={api}
          successedUpload={onUpload}
        />
      </div>
    )
  }

  return (
    <div className={styles.core}>
      <CardDocuments hasHeader={false} data={fileObj} />
    </div>
  )
}
